import React, { useState } from "react";
import { api } from "../../lib/api";
import { Alert, Card, btn, input } from "../workforce/common";

const msg = (e) => e?.response?.data?.detail?.message || "Something went wrong.";

function Item({ it, pid, canManage, readOnly, onChange, setErr }) {
  const [note, setNote] = useState("");
  const run = (p) => p.then((r) => { setErr(""); onChange(r?.data); }).catch((e) => setErr(msg(e)));
  const upload = (f) => { const fd = new FormData(); fd.append("file", f); run(api.post(`/closeout/projects/${pid}/items/${it.key}/upload`, fd)); };
  return (
    <li className="rounded border border-erf-borderCream bg-white p-3 text-sm space-y-2" data-testid={`co-item-${it.key}`}>
      <div className="flex items-start justify-between gap-2">
        <span className="font-semibold">{it.label}</span>
        <span className={`shrink-0 text-xs font-semibold ${it.done ? "text-green-800" : "text-amber-800"}`} data-testid={`co-item-state-${it.key}`}>{it.na ? "N/A" : it.done ? "Done" : "Open"}</span>
      </div>
      {it.detail && <p className="text-xs break-words">{it.detail}</p>}
      {!readOnly && canManage && !it.done && (
        <div className="flex flex-wrap items-end gap-2">
          {it.kind === "document" && <>
            <label htmlFor={`co-up-${it.key}`} className={`${btn} inline-flex items-center cursor-pointer`}>Upload file</label>
            <input id={`co-up-${it.key}`} type="file" className="sr-only" onChange={(e) => e.target.files[0] && upload(e.target.files[0])} data-testid={`co-upload-${it.key}`} /></>}
          {it.kind === "manual" && <button type="button" className={btn} onClick={() => run(api.post(`/closeout/projects/${pid}/items/${it.key}/mark`, { state: "done", note }))} data-testid={`co-done-${it.key}`}>Mark done</button>}
          <label htmlFor={`co-na-${it.key}`} className="sr-only">Reason for N/A</label>
          <input id={`co-na-${it.key}`} className={`${input} flex-1 min-w-[160px]`} placeholder="Reason if not applicable" value={note} onChange={(e) => setNote(e.target.value)} data-testid={`co-na-reason-${it.key}`} />
          <button type="button" className={btn} onClick={() => run(api.post(`/closeout/projects/${pid}/items/${it.key}/mark`, { state: "na", note }))} data-testid={`co-na-${it.key}`}>Mark N/A</button>
        </div>)}
    </li>
  );
}

export default function Checklist({ data, pid, canManage, reload }) {
  const [err, setErr] = useState("");
  const readOnly = data.read_only;
  return (
    <section className="space-y-3" data-testid="co-checklist">
      <Card testid="co-summary" className="flex flex-wrap items-center justify-between gap-2">
        <span data-testid="co-complete">{data.complete ? "Checklist complete" : `${data.missing.length} item(s) open`}</span>
        <span className="text-xs" data-testid="co-status">Project: {data.project_status}{readOnly ? " · read-only" : ""}</span>
      </Card>
      <Alert text={err} testid="co-error" />
      <ul className="space-y-2">{data.items.map((it) => <Item key={it.key} it={it} pid={pid} canManage={canManage} readOnly={readOnly} onChange={reload} setErr={setErr} />)}</ul>
    </section>
  );
}
